module.exports = __webpack_public_path__ + "img/network-icon-neon-blue.7ddd07aa.png";